import { Image, Nav, Navbar } from "react-bootstrap";
import { useAuth } from "react-oidc-context";
import { Link, useLocation, useNavigate } from "react-router";
import UserNavItem from "./UserNavItem.jsx";

import { authorized } from "../../utils/authorizationUtils.js";
import { getRedirectPath } from "../../utils/pathnameUtils.js";

import { getHostFromEnv } from "../../constants/api/config.ts";
import sitePaths from "../../constants/sitePaths.js";

import {
    bypatruljen,
    bypatruljenAll,
    bypatruljenAndJuridiskAll,
    ileggelseadmin,
    innsyn,
    juridisk,
    juridiskAll,
    skiftlogg,
    stedfortrederDriftsleder,
} from "../../constants/roles.js";

import { default as byvaapen, default as byvaapen2x, default as byvappen3x } from "../../images/Oslo-logo-sort-RGB.svg";
import "./NavigationBar.css";

function NavigationBar() {
  const auth = useAuth();
  const navigate = useNavigate();
  const location = useLocation();

  const getIleggelseNavigationPath = () => {
    if (
      window.location.pathname === sitePaths.ileggelser.ettersendelser.shortUrl
    ) {
      return sitePaths.ileggelser.ettersendelser.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.ileggelser.ettersendelserTilGodkjenning.shortUrl
    ) {
      return sitePaths.ileggelser.ettersendelserTilGodkjenning.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.ileggelser.elsparksykkelGebyr.shortUrl
    ) {
      return sitePaths.ileggelser.elsparksykkelGebyr.shortUrl;
    }
    return sitePaths.ileggelser.oversikt.shortUrl;
  };

  const getMiljogebyrNavigationPath = () => {
    if (
      window.location.pathname === sitePaths.miljogebyrer.tilBehandling.shortUrl
    ) {
      return sitePaths.miljogebyrer.tilBehandling.shortUrl;
    } else if (
      window.location.pathname ===
      sitePaths.miljogebyrer.miljokontrolloversikt.shortUrl
    ) {
      return sitePaths.miljogebyrer.miljokontrolloversikt.shortUrl;
    }
    return sitePaths.miljogebyrer.oversikt.shortUrl;
  };

  const getUregistrerteNavigationPath = () => {
    return sitePaths.uregistrerte.kontroller.shortUrl;
  };

  const getGrunndataNavigationPath = () => {
    if (window.location.pathname === sitePaths.grunndata.aktorer) {
      return sitePaths.grunndata.aktorer;
    }
    if (window.location.pathname === sitePaths.grunndata.bypatruljen) {
      return sitePaths.grunndata.bypatruljen;
    }
    if (window.location.pathname === sitePaths.grunndata.farger) {
      return sitePaths.grunndata.farger;
    }
    if (window.location.pathname === sitePaths.grunndata.kjoretoyMerker) {
      return sitePaths.grunndata.kjoretoyMerker;
    }
    if (window.location.pathname === sitePaths.grunndata.kjoretoyTyper) {
      return sitePaths.grunndata.kjoretoyTyper;
    }
    if (
      window.location.pathname ===
      sitePaths.grunndata.overtredelseskoderIleggelser
    ) {
      return sitePaths.grunndata.overtredelseskoderIleggelser;
    }
    if (
      window.location.pathname ===
      sitePaths.grunndata.overtredelseskoderMiljogebyr
    ) {
      return sitePaths.grunndata.overtredelseskoderMiljogebyr;
    }
    if (
      window.location.pathname === sitePaths.grunndata.internkoderIleggelser
    ) {
      return sitePaths.grunndata.internkoderIleggelser;
    }
    if (
      window.location.pathname === sitePaths.grunndata.internkoderMiljogebyr
    ) {
      return sitePaths.grunndata.internkoderMiljogebyr;
    }
    if (window.location.pathname === sitePaths.grunndata.nasjoner) {
      return sitePaths.grunndata.nasjoner;
    }
    if (window.location.pathname === sitePaths.grunndata.rettekoder) {
      return sitePaths.grunndata.rettekoder;
    }
    if (window.location.pathname === sitePaths.grunndata.vedtakskoder) {
      return sitePaths.grunndata.vedtakskoder;
    }
    return sitePaths.grunndata.shortUrl;
  };

  const getRapporterNavigationPath = () => {
    if (window.location.pathname === sitePaths.rapporter.skiftlogg.oversikt) {
      return sitePaths.rapporter.skiftlogg.oversikt;
    }
    if (
      window.location.pathname ===
      sitePaths.rapporter.piggdekkontroller.oversikt
    ) {
      return sitePaths.rapporter.piggdekkontroller.oversikt;
    }
    if (window.location.pathname === sitePaths.rapporter.klager.oversikt) {
      return sitePaths.rapporter.klager.oversikt;
    }
    if (
      window.location.pathname ===
      sitePaths.rapporter.juridiskSaksbehandler.oversikt
    ) {
      return sitePaths.rapporter.juridiskSaksbehandler.oversikt;
    }
    if (
      window.location.pathname ===
      sitePaths.rapporter.uferdigstilteKlagesaker.oversikt
    ) {
      return sitePaths.rapporter.uferdigstilteKlagesaker.oversikt;
    }
    if (
      window.location.pathname ===
      sitePaths.rapporter.antallIleggelserPerIleggelsetype.oversikt
    ) {
      return sitePaths.rapporter.antallIleggelserPerIleggelsetype.oversikt;
    }
    if (
      window.location.pathname === sitePaths.rapporter.makuleringer.oversikt
    ) {
      return sitePaths.rapporter.makuleringer.oversikt;
    }
    if (window.location.pathname === sitePaths.rapporter.aarsrapport.oversikt) {
      return sitePaths.rapporter.aarsrapport.oversikt;
    }
    if (
      window.location.pathname ===
      sitePaths.rapporter.ubetalteIleggelser.oversikt
    ) {
      return sitePaths.rapporter.ubetalteIleggelser.oversikt;
    }
    if (
      window.location.pathname.search(
        sitePaths.rapporter.ubetalteIleggelser.detalj.matcher,
      ) === 0
    ) {
      return window.location.pathname;
    }

    return getRedirectPath(sitePaths.rapporter.shortUrl);
  };

  const getRapporterNavigationPathAndSearch = () => {
    if (
      window.location.pathname.search(
        sitePaths.rapporter.ubetalteIleggelser.detalj.matcher,
      ) === 0
    ) {
      return window.location.pathname + window.location.search;
    }
    return getRapporterNavigationPath();
  };

  const getInnkrevingNavigationPath = () => {
    if (
      window.location.pathname ===
      sitePaths.innkreving.miljogebyr.venter.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.venter.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.miljogebyr.stoppet.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.stoppet.shortUrl;
    }
    if (
      window.location.pathname === sitePaths.innkreving.miljogebyr.klar.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.klar.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.miljogebyr.behandlesInnkreving.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.behandlesInnkreving.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.miljogebyr.feilet.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.feilet.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.miljogebyr.vellykket.shortUrl
    ) {
      return sitePaths.innkreving.miljogebyr.vellykket.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.ileggelser.venter.shortUrl
    ) {
      return sitePaths.innkreving.ileggelser.venter.shortUrl;
    }
    if (
      window.location.pathname === sitePaths.innkreving.ileggelser.klar.shortUrl
    ) {
      return sitePaths.innkreving.ileggelser.klar.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.ileggelser.behandlesInnkreving.shortUrl
    ) {
      return sitePaths.innkreving.ileggelser.behandlesInnkreving.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.ileggelser.feilet.shortUrl
    ) {
      return sitePaths.innkreving.ileggelser.feilet.shortUrl;
    }
    if (
      window.location.pathname ===
      sitePaths.innkreving.ileggelser.vellykket.shortUrl
    ) {
      return sitePaths.innkreving.ileggelser.vellykket.shortUrl;
    }
    return sitePaths.innkreving.ileggelser.default;
  };

  const getInnsynNavigationPath = () => {
    if (window.location.pathname === sitePaths.innsyn.miljogebyrer.oversikt) {
      return sitePaths.innsyn.miljogebyrer.oversikt;
    }
    if (
      authorized([
        ...bypatruljenAll,
        ...juridiskAll,
        stedfortrederDriftsleder,
      ]) &&
      window.location.pathname === sitePaths.innsyn.ileggelser.oversikt
    ) {
      return sitePaths.innsyn.ileggelser.oversikt;
    }
    if (
      authorized([
        innsyn.vaktsentralen,
        innsyn.serviceavdeling,
        innsyn.kemnerkontoret,
        innsyn.seksjonssjefVaktsentralen,
      ]) &&
      window.location.pathname === sitePaths.innsyn.motorvogn.shortUrl
    ) {
      return sitePaths.innsyn.motorvogn.shortUrl;
    }
    if (
      authorized([ileggelseadmin]) &&
      window.location.pathname === sitePaths.innsyn.personopplysninger
    ) {
      return sitePaths.innsyn.personopplysninger;
    }
    return getRedirectPath(sitePaths.innsyn.shortUrl);
  };

  const getBackgroundColorLeft = () => {
    if (window.location.origin.includes("localhost"))
      return "rgba(255, 0, 0, 0.3)";
    if (
      window.location.origin.includes("client-dev") ||
      window.location.origin.includes(".dev.")
    )
      return "rgba(255, 255, 0, 0.3)";
    if (
      window.location.origin.includes("external-client-dev") ||
      window.location.origin.includes(".external-dev.")
    )
      return "rgba(0, 255, 0, 0.3)";
    if (
      window.location.origin.includes("client-test") ||
      window.location.origin.includes(".test.")
    )
      return "rgba(0, 0, 255, 0.3)";
    return "transparent";
  };

  const getBackgroundColorRight = () => {
    const environment = getHostFromEnv("URL_SERVICE");
    if (environment.includes("localhost")) return "rgba(255, 0, 0, 0.3)";
    if (environment.includes("dev")) return "rgba(255, 255, 0, 0.3)";
    if (environment.includes("test")) return "rgba(0, 0, 255, 0.3)";
    return "transparent";
  };

  const getBackgroundColor = () => {
    return {
      backgroundImage: `linear-gradient(to right, ${getBackgroundColorLeft()}, ${getBackgroundColorRight()})`,
    };
  };

  const handleLinkClick = (e, url) => {
    e.preventDefault();
    navigate(url);
  };

  const hideNavBar =
    location.pathname.search(
      "/" +
        "(" +
        "ileggelser/oversikt|" +
        "ileggelser/ettersendelser|" +
        "ileggelser/ettersendelser-til-godkjenning|" +
        "ileggelser/elsparksykkel-gebyr|" +
        "miljogebyrer/oversikt|" +
        "miljogebyrer/oversikt/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller|" +
        "miljogebyrer/til-behandling|" +
        "miljogebyrer/til-behandling/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller|" +
        "miljogebyrer/tidskontrolloversikt|" +
        "miljogebyrer/tidskontrolloversikt/miljogebyrer|" +
        "miljogebyrer/tidskontrolloversikt/miljogebyrer/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller|" +
        "miljogebyrer/tidskontrolloversikt/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/miljogebyrer|" +
        "uregistrerte/kontroller|" +
        "rapporter/ventilstillinger|" +
        "rapporter/ventilstillinger/ileggelse|" +
        "rapporter/ventilstillinger/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/ileggelse|" +
        "rapporter/ubetalte-ileggelser/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/ileggelser|" +
        "innsyn/motorvogn|" +
        "innsyn/ileggelser|" +
        "innsyn/miljogebyrer|" +
        "innsyn/personopplysninger|" +
        "klage/ileggelser|" +
        "klage/miljogebyrer|" +
        "klage/miljogebyrer/[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/tidskontroller|" +
        "innkreving/ileggelser/venter|" +
        "innkreving/ileggelser/stoppet|" +
        "innkreving/ileggelser/klar|" +
        "innkreving/ileggelser/behandles-innkreving|" +
        "innkreving/ileggelser/feilet|" +
        "innkreving/ileggelser/vellykket|" +
        "innkreving/miljogebyr/venter|" +
        "innkreving/miljogebyr/stoppet|" +
        "innkreving/miljogebyr/klar|" +
        "innkreving/miljogebyr/behandles-innkreving|" +
        "innkreving/miljogebyr/feilet|" +
        "innkreving/miljogebyr/vellykket|" +
        ")" +
        "/" +
        "(" +
        "[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}$|" +
        "utskrift|" +
        "[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/utskrift|" +
        "[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/svar-ut/|[a-z0-9]{8}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{4}-[a-z0-9]{12}/historikk|" +
        "/admin" +
        ")",
    ) === 0;

  if (hideNavBar) {
    return null;
  }

  return (
    <Navbar
      className="navbar-bym no-print"
      expand="lg"
      style={getBackgroundColor()}
    >
      <Navbar.Brand>
        <Link to="/">
          <Image
            className="byvaap-cmyk"
            src={byvaapen}
            srcSet={`${byvaapen2x} 2x,${byvappen3x} 3x`}
          />
          <div className="brand-post-text">| HGK</div>
        </Link>
      </Navbar.Brand>
      <Navbar.Toggle />
      <Navbar.Collapse>
        {auth?.isAuthenticated && (
          <Nav activeKey={window.location.pathname}>
            {authorized([
              ...Object.values(bypatruljen),
              ...Object.values(juridisk),
              stedfortrederDriftsleder,
            ]) && (
              <Nav.Link
                href={getIleggelseNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getIleggelseNavigationPath())
                }
              >
                Ileggelse
              </Nav.Link>
            )}
            {authorized([
              ...Object.values(bypatruljen),
              ...Object.values(juridisk),
              stedfortrederDriftsleder,
            ]) && (
              <Nav.Link
                href={getMiljogebyrNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getMiljogebyrNavigationPath())
                }
              >
                Miljøgebyr
              </Nav.Link>
            )}
            {authorized([
              ...Object.values(bypatruljen),
              ...Object.values(juridisk),
              innsyn.vaktsentralen,
              innsyn.serviceavdeling,
            ]) && (
              <Nav.Link
                href={getUregistrerteNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getUregistrerteNavigationPath())
                }
              >
                Uregistrerte
              </Nav.Link>
            )}
            {authorized([
              bypatruljen.saksbehandler,
              bypatruljen.saksbehandleradmin,
              ...Object.values(juridisk),
            ]) && (
              <Nav.Link
                href={getInnkrevingNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getInnkrevingNavigationPath())
                }
              >
                Innkreving
              </Nav.Link>
            )}
            {authorized([
              bypatruljen.saksbehandleradmin,
              ...Object.values(juridisk),
            ]) && (
              <Nav.Link
                href={sitePaths.klage.default}
                onClick={(e) => handleLinkClick(e, sitePaths.klage.default)}
              >
                Klage
              </Nav.Link>
            )}
            {authorized([
              bypatruljen.saksbehandler,
              bypatruljen.saksbehandleradmin,
              bypatruljen.avdelingdirektor,
              bypatruljen.seksjonssjefStab,
              bypatruljen.seksjonssjef,
              bypatruljen.driftleder,
              ...Object.values(juridisk),
              innsyn.vaktsentralen,
              innsyn.serviceavdeling,
              innsyn.seksjonssjefVaktsentralen,
            ]) && (
              <Nav.Link
                href={getGrunndataNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getGrunndataNavigationPath())
                }
              >
                Grunndata
              </Nav.Link>
            )}
            {authorized([
              ...Object.values(bypatruljen),
              ...Object.values(juridisk),
              skiftlogg,
              stedfortrederDriftsleder,
            ]) && (
              <Nav.Link
                href={getRapporterNavigationPath()}
                onClick={(e) =>
                  handleLinkClick(e, getRapporterNavigationPathAndSearch())
                }
              >
                Rapporter
              </Nav.Link>
            )}
            {authorized([
              ...Object.values(bypatruljen),
              ...Object.values(juridisk),
              innsyn.vaktsentralen,
              innsyn.serviceavdeling,
              innsyn.kemnerkontoret,
              innsyn.seksjonssjefVaktsentralen,
              stedfortrederDriftsleder,
            ]) && (
              <Nav.Link
                href={getInnsynNavigationPath()}
                onClick={(e) => handleLinkClick(e, getInnsynNavigationPath())}
              >
                Innsyn
              </Nav.Link>
            )}
            {authorized([
              ...bypatruljenAndJuridiskAll,
              innsyn.seksjonssjefVaktsentralen,
              innsyn.vaktsentralen,
              innsyn.serviceavdeling,
            ]) && (
              <Nav.Link
                href={sitePaths.linker}
                onClick={(e) => handleLinkClick(e, sitePaths.linker)}
              >
                Lenker
              </Nav.Link>
            )}
            {authorized([ileggelseadmin]) && (
              <Nav.Link
                href={sitePaths.status}
                onClick={(e) => handleLinkClick(e, sitePaths.status)}
              >
                Status
              </Nav.Link>
            )}
            <UserNavItem />
          </Nav>
        )}
      </Navbar.Collapse>
    </Navbar>
  );
}

export default NavigationBar;